import { DbacksTcModal } from "../config/tc_helper_dbacks";
import { PacksModal } from "@/shared/modules/PurchaseSeats/modals/PacksModal";
import { InventoryPreviewModal } from "@/shared/modules/PurchaseSeats/InventoryPreview/InventoryPreviewModal";
import { DynamicPricingModal } from "@/shared/modules/PurchaseSeats/modals/DynamicPricingModal";
import { ManagePerkErrorModal } from "@/shared/modules/PurchaseSeats/modals/ManagePerkErrorModal";
import { SPEventSelectorModal } from "@/shared/modules/PurchaseSeats/modals/SPEventSelectorModal";
import { PerkImageSliderModal } from "@/shared/modules/PurchaseSeats/SelectPerks/PerkImageSliderModal";
import { SPEventRemoveConfirmModal } from "@/shared/modules/PurchaseSeats/modals/SPEventRemoveConfirmModal";
import { ConfirmEventSelectionLossModal } from "@/shared/modules/PurchaseSeats/modals/ConfirmEventSelectionLossModal";
import { CancelCartWarningModal } from "@/shared/modules/PurchaseSeats/modals/CancelCartWarningModal";
import { AddRecipientModal } from "@/shared/modules/ticketTransfer/AddRecipientModal";
import { UpdateRecipientStatusModal } from "@/shared/modules/ticketTransfer/UpdateRecipientStatusModal";
import { GenericModal } from "@/shared/common/GenericModal";
import { TransactionErrorGenericModal } from "@/shared/modules/PurchaseSeats/modals/TransactionErrorGenericModal";
import { NoInventoryAlertModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/force-event-selection/NoInventoryAlertModal";
import { ChooseMissingBucketEventsModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/force-event-selection/ChooseMissingBucketEventsModal";
import { ChooseMissingRegularEventsModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/force-event-selection/ChooseMissingRegularEventsModal";
import { ChooseMissingPackageEventsModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/force-event-selection/ChooseMissingPackageEventsModal";
import { AutoSeatSelectionAlertModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/auto-seat-selection/AutoSeatSelectionAlertModal";
import { AutoSeatSelectionProgressModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/auto-seat-selection/AutoSeatSelectionProgressModal";
import { AutoSeatSelectionNoInventoryAlertModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/auto-seat-selection/AutoSeatSelectionNoInventoryAlertModal";
import { MaxLimitErrorModal } from "@/shared/modules/PurchaseSeats/modals/MaxLimitErrorModal";
import { DiffSeatsAlertModal } from "@/shared/modules/PurchaseSeats/ChooseSeats/diff-seats/DiffSeatsAlertModal";
import { UnlockExclusiveAccessModal } from "@/shared/modules/PurchaseSeats/modals/UnlockExclusiveAccessModal";

export function GlobalModals() {
  return (
    <>
      {/* Generic Modal, can display errors, info, success or warnings */}
      <GenericModal />

      {/* dbacks terms and conditions modal, switch is in team config helpers */}
      <DbacksTcModal />

      {/* special event selector modal */}
      <SPEventSelectorModal />

      {/* special event remove confirm modal */}
      <SPEventRemoveConfirmModal />

      {/* inventory preview modal */}
      <InventoryPreviewModal />

      {/* managePerk failed resolver modal */}
      <ManagePerkErrorModal />

      {/* packs modal */}
      <PacksModal />

      {/* unlock exclusive access modal */}
      <UnlockExclusiveAccessModal />

      {/* confirm event selection loss modal */}
      <ConfirmEventSelectionLossModal />

      {/* dynamic pricing modal */}
      <DynamicPricingModal />

      {/* merchandising modal - used in perks page */}
      <PerkImageSliderModal />

      {/* cancel cart warning modal */}
      <CancelCartWarningModal />

      {/* Add recipient modal to the ticket group */}
      <AddRecipientModal />

      {/* Update recipient status modal */}
      <UpdateRecipientStatusModal />

      {/** transaction error generic modal */}
      <TransactionErrorGenericModal />

      {/* No inventory message modal */}
      <NoInventoryAlertModal />

      {/* choose bucket event modal */}
      <ChooseMissingBucketEventsModal />

      {/* choose regular event modal */}
      <ChooseMissingRegularEventsModal />

      {/* choose package event modal */}
      <ChooseMissingPackageEventsModal />

      {/* diff seats alert modal */}
      <DiffSeatsAlertModal />

      {/* hold similar seats alert modal */}
      <AutoSeatSelectionAlertModal />

      {/* hold similar seats progress modal */}
      <AutoSeatSelectionProgressModal />

      {/* auto seat selection no inventory alert modal */}
      <AutoSeatSelectionNoInventoryAlertModal />

      {/* max limit error modal */}
      <MaxLimitErrorModal />
    </>
  );
}
